unit NetStatusType;

interface

uses
  TypeType;

type
  TNetStatusType = class
  private
    fNetStatusKey: String;
    fCode: String;
    fName: String;
    fOrder: Word;
    fDeviceType: TTypeType;
    fTimeToFinish: Word;
    fActive: Boolean;
  public
    property NetStatusKey: String read fNetStatusKey;
    property Code: String read fCode;
    property Name: String read fName;
    property Order: Word read fOrder;
    property DeviceType: TTypeType read fDeviceType;
    property TimeToFinish: Word read fTimeToFinish;
    property Active: Boolean read fActive;
    constructor Create(const String_NetStatusKey: String);
  end;

implementation

constructor TNetStatusType.Create(const String_NetStatusKey: String);
begin
  inherited Create();

  fNetStatusKey := String_NetStatusKey;
end;

end.
